<template>
  <div class="grid">
    <Loader v-if="loadingL" />
    <!-- <div class="col-12 lg:col-6 xl:col-2">
			<div v-on:click="go_to_hoardings()">
				<div class="card mb-0">
					<div class="flex justify-content-between">
						<div>
							<span class="block text-500 font-medium mb-3">Total <br>Hoardings</span>
							<div class="text-900 font-medium text-xl">{{ dashcount.Total_hoardings }}</div>
						</div>
						<div class="flex align-items-center justify-content-center bg-purple-100 border-round"
							style="width:2.5rem;height:2.5rem">
							<i class="pi pi-comment text-purple-500 text-xl"></i>
						</div>
					</div>
				</div>
			</div>
		</div> -->
    <div class="col-12 lg:col-6 xl:col-2">
      <div v-on:click="go_to_applications()">
        <div class="card mb-0">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium mb-3"
                >Total<br />
                Applications</span
              >
              <div class="text-900 font-medium text-xl">
                {{ dashcount.total_application }}
              </div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-blue-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-fw pi-user text-blue-500 text-xl"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-2">
      <div v-on:click="go_to_pending_applications()">
        <div class="card mb-0">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium mb-3"
                >Pending<br />
                Applications</span
              >
              <div class="text-900 font-medium text-xl">
                {{ dashcount.pending_application }}
              </div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-orange-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-fw pi-user text-orange-500 text-xl"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-2">
      <div v-on:click="go_to_rejected_applications()">
        <div class="card mb-0">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium mb-3"
                >Rejected<br />
                Applications</span
              >
              <div class="text-900 font-medium text-xl">
                {{ dashcount.rejected_application }}
              </div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-cyan-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-inbox text-cyan-500 text-xl"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-2">
      <div v-on:click="go_to_approved_applications()">
        <div class="card mb-0">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium mb-3"
                >Approved<br />
                Applications</span
              >
              <div class="text-900 font-medium text-xl">
                {{ dashcount.approved_application }}
              </div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-purple-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-comment text-purple-500 text-xl"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-2">
      <div v-on:click="go_to_complaints()">
        <div class="card mb-0">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium mb-3"
                >Total <br />Complaints</span
              >
              <div class="text-900 font-medium text-xl">
                {{ dashcount.total_complaints }}
              </div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-purple-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-comment text-purple-500 text-xl"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-2">
      <div v-on:click="go_to_hoardings()">
        <div class="card mb-0">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium mb-3"
                >Total <br />Notifications</span
              >
              <div class="text-900 font-medium text-xl">8</div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-cyan-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-comment text-cyan-500 text-xl"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-12 xl:col-12">
      <!-- <div class="card">
				<h3>Hoardings</h3>
				<div class="p-fluid formgrid grid" style="margin-bottom: 2%;">
					<div class="p-field col-12 md:col-3">
						<span class="p-float-label">
							<Dropdown id="User" filter v-model="state_dropdownItem" :options="state_dropdownItems"
								optionLabel="name" :value="state_dropdownItems.value" @change="getDistrictData"
								display="chip">
							</Dropdown>
							<label for="complaint_status">State</label>
						</span>
					</div>
					<div class="p-field col-12 md:col-3">
						<span class="p-float-label">
							<Dropdown id="User" filter v-model="district_dropdownItem"
								:options="district_dropdownItems" optionLabel="name" @change="getMuncipalCorporationData"
								 display="chip">
							</Dropdown>
							<label for="complaint_status">District</label>
						</span>
					</div>
					<div class="p-field col-12 md:col-3">
						<span class="p-float-label">
							<Dropdown id="User" filter v-model="mcorporation_dropdownItem"
								:options="mcorporation_dropdownItems" optionLabel="name" 
								display="chip">
							</Dropdown>
							<label for="complaint_status">Muncipal Corporation</label>
						</span>
					</div>
					<div class="p-field col-12 md:col-3">
						<Button icon="pi pi-search" @click="search_people" class="p-button-rounded color"
							v-tooltip.bottom="'Search'" />&nbsp;
						<Button icon="pi pi-refresh" @click="reset_search_people" class="p-button-rounded color"
							v-tooltip.bottom="'Reset'" />
					</div>
				</div>
				<GoogleMap api-key="AIzaSyC-8ib8PMibUDDYoj5kzRzKwcusvw3Gztc" style="width: 100%; height: 500px"
					:center="center" :zoom="7">
					<MarkerCluster>
						<Marker v-for="(location, i) in hoarding_filter" :options="{ position: location }" :key="i">
							<InfoWindow>
								<div id="contet" style="width:350px">
									<div id="bodyContent" class="grid" >
										<div class="col-12 lg:col-12 lg:col-12">
											<b>Hoarding Name :</b> {{ hoardings_date[i]['HoardingName'] }} <br>
											<b>Hoarding State :</b> {{ hoardings_date[i]['State_name'] }} <br>
											<b>Hoarding District :</b> {{ hoardings_date[i]['district_name'] }} <br>
											<b>Hoarding Type :</b> {{ hoardings_date[i]['HoardingType'] }} <br>
											<b>Hoarding MunicipalCorporation :</b> {{ hoardings_date[i]['MunicipalCorporation'] }}
										</div>
									</div>
								</div>
							</InfoWindow>
						</Marker>
					</MarkerCluster>
				</GoogleMap>
			</div> -->
			<div class="card">
				<h3>Applications</h3>
        <Chart type="line" :data="chartData" :options="chartOptions" class="h-30rem" />
    </div>
    </div>
		
  </div>
</template>
<script>
import EventBus from "@/AppEventBus";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import Loader from "../components/Loader.vue";
import {
  GoogleMap,
  Marker,
  MarkerCluster,
  InfoWindow,
  GMapMarker,
  Polyline,
} from "vue3-google-map";
export default {
  data() {
    return {
			chartData: null,
      chartOptions: null,
      loadingL: false,
      state_dropdownItems: [],
      state_dropdownItem: null,
      district_dropdownItems: [],
      district_dropdownItem: null,
      mcorporation_dropdownItems: [],
      mcorporation_dropdownItem: null,
      hoardings_date: [],
      center: { lat: 19.0626704, lng: 73.005094 },
      hoarding_filter: [],
      get_date: "",
      get_date_2: "",
      products: null,
      todayslectures: [],
      dashcount: {
        total_hoarding: 0,
        total_application: 0,
        pending_application: 0,
        rejected_application: 0,
        approved_application: 0,
        total_complaints: 0,
      },
      lineData: {
        labels: [
          "0",
          "0 to 20",
          "20 to 40",
          "40 to 60",
          "60 to 80",
          "80 to 100",
        ],
        datasets: [
          {
            label: "Network",
            data: [],
            backgroundColor: "#00bb7e",
          },
          // {
          // 	label: 'Sales',
          // 	data: [],
          // 	fill: false,
          // 	backgroundColor: '#00bb7e',
          // 	borderColor: '#00bb7e',
          // 	tension: 0.4
          // }
        ],
      },
      barData: {
        labels: [
          "0 to 1 GB",
          "1 to 4 GB",
          "4 to 6 GB",
          "6 to 10 GB",
          "10 GB Above",
        ],
        datasets: [
          {
            label: "Data Usages",
            backgroundColor: "#2f4860",
            data: [],
          },
        ],
      },
      barData1: {
        labels: [],
        datasets: [
          {
            label: "No Of Lectures by Teacher",
            backgroundColor: "#2f4860",
            data: [],
          },
        ],
      },
      barOptions: null,
      barOptions1: null,
      items: [
        { label: "Add New", icon: "pi pi-fw pi-plus" },
        { label: "Remove", icon: "pi pi-fw pi-minus" },
      ],
      lineOptions: null,
    };
  },
  productService: null,
  themeChangeListener: null,
  mounted() {
		this.chartData = this.setChartData();
    this.chartOptions = this.setChartOptions();
    this.productService
      .getProductsSmall()
      .then((data) => (this.products = data));
    this.themeChangeListener = (event) => {
      if (event.dark) this.applyDarkTheme();
      else this.applyLightTheme();
    };
    EventBus.on("change-theme", this.themeChangeListener);
    if (this.isDarkTheme()) {
      this.applyDarkTheme();
    } else {
      this.applyLightTheme();
    }
    this.dashboardcount();
    // this.get_date=new Date();
    // this.datausagereport();
    // this.get_date_2=new Date();
    // this.networkconnectivityreport();
    // this.todayslecturereport();
    // this.teacherlecturereportadmin();
  },
  beforeUnmount() {
    EventBus.off("change-theme", this.themeChangeListener);
  },
  created() {
    this.productService = new ProductService();
    this.getStateData();
    this.getDistrictData();
    this.getMuncipalCorporationData();
    this.get_complaint_count();
    this.search_people();
  },
  watch: {
    get_date() {
      this.datausagereport();
    },
    get_date_2() {
      this.networkconnectivityreport();
    },
  },
  methods: {
		setChartData() {
            const documentStyle = getComputedStyle(document.documentElement);

            return {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July','Aug','Sept','Oct','Nov','Dec'],
                datasets: [
                    {
                        label: 'Applications',
                        data: [10, 0, 0, 0, 0, 0, 0,0,1,0,0,0],
                        fill: false,
                        borderColor: documentStyle.getPropertyValue('--cyan-500'),
                        tension: 0.4
                    },
                    
                ]
            };
        },
        setChartOptions() {
            const documentStyle = getComputedStyle(document.documentElement);
            const textColor = documentStyle.getPropertyValue('--text-color');
            const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
            const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

            return {
                maintainAspectRatio: false,
                aspectRatio: 0.6,
                plugins: {
                    legend: {
                        labels: {
                            color: textColor
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    },
                    y: {
                        ticks: {
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    }
                }
            };
        },
    search_people() {
      var state = "";
      var district = "";
      var muncipal = "";
      if (this.state_dropdownItem) {
        state = this.state_dropdownItem.value;
      }
      if (this.district_dropdownItem) {
        district = this.district_dropdownItem.value;
      }
      if (this.mcorporation_dropdownItem) {
        muncipal = this.mcorporation_dropdownItem.value;
      }
      var data = {
        count: false,
        state_id: state,
        district_id: district,
        muncipal_corporation_id: muncipal,
      };
      console.log("data--", data);
      // return false;
      this.loadingL = true;
      var promise = apis.DashboardSearch(data);
      promise.then((response) => {
        this.loadingL = false;
        if (response.data.data) {
          var temp_data = response.data.data;
          this.hoardings_date = [];
          this.hoardings_date = temp_data;
          this.hoarding_filter = [];
          for (let index = 0; index < temp_data.length; index++) {
            if (
              temp_data[index]["HoardingLocation_Lat"] &&
              temp_data[index]["HoardingLocation_Lng"]
            ) {
              var lat = parseFloat(temp_data[index]["HoardingLocation_Lat"]);
              var lng = parseFloat(temp_data[index]["HoardingLocation_Lng"]);
              this.hoarding_filter.push({ lat: lat, lng: lng });
            }
          }
        }
      });
    },
    getStateData() {
      this.state_dropdownItems = [];
      var data = {};
      // return false;
      this.loading = true;
      var promise = apis.StateList(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          console.log("state data--", this.state_dropdownItems);
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].State_name,
              value: response.data.data[x].State_id,
            });
          }
          this.state_dropdownItem = null;
          this.state_dropdownItems = temp_data;
        }
      });
    },
    getDistrictData() {
      this.district_dropdownItems = [];
      var state_id = "";
      if (this.state_dropdownItem) {
        var state_id = this.state_dropdownItem.value;
      }
      var data = {
        state_id: state_id,
      };
      // return false;
      this.loading = true;
      var promise = apis.DistrictList(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          console.log("District data--", this.district_dropdownItems);
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].DistrictID,
            });
          }
          this.district_dropdownItem = null;
          this.district_dropdownItems = temp_data;
        }
      });
    },
    getMuncipalCorporationData() {
      this.mcorporation_dropdownItems = [];
      var district_id = "";
      if (this.district_dropdownItem) {
        var district_id = this.district_dropdownItem.value;
      }
      var data = {
        district_id: district_id,
      };
      // return false;
      this.loading = true;
      var promise = apis.MuncipalCorporationList(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          console.log(
            "Muncipal Corporation data--",
            this.mcorporation_dropdownItems
          );
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].MunicipalCorporation,
              value: response.data.data[x].id,
            });
          }
          this.mcorporation_dropdownItem = null;
          this.mcorporation_dropdownItems = temp_data;
        }
      });
    },
    reset_search_people() {
      this.state_dropdownItem = null;
      this.district_dropdownItem = null;
      this.mcorporation_dropdownItem = null;
      this.search_people();
    },
    go_to_student() {
      //alert(987)
      this.$router.push("/studentmaster");
    },
    go_to_hoardings() {
      //alert(987)
      this.$router.push("/hoardinglist");
    },
    go_to_applications() {
      //alert(987)
      this.$router.push("/NewApplicationList");
    },
    go_to_pending_applications() {
      //alert(987)
      this.$router.push("/ApplicationList");
    },
    go_to_rejected_applications() {
      //alert(987)
      this.$router.push("/RejectApplicationList");
    },
    go_to_approved_applications() {
      //alert(987)
      this.$router.push("/ApprovedApplicationList");
    },
    go_to_complaints() {
      //alert(987)
      this.$router.push("/complaintlist");
    },
    dashboardcount() {
      var Municipal_CorporationID = "";
      Municipal_CorporationID = localStorage.getItem("Municipal_CorporationID")
        ? localStorage.getItem("Municipal_CorporationID")
        : "";
      var data = {
        DistrictID: localStorage.getItem("DistrictID")
          ? localStorage.getItem("DistrictID")
          : "",
        Municipal_CorporationID: Municipal_CorporationID,
        StateID: localStorage.getItem("StateID")
          ? localStorage.getItem("StateID")
          : "",
        RoleID: localStorage.getItem("user_role_id")
          ? localStorage.getItem("user_role_id")
          : "",
      };
      var promise = apis.dashboardcount(data);
      promise.then((response) => {
        this.dashcount["Total_hoardings"] =
          response.data.data["Total_hoardings"][0]["count"];
        this.dashcount["total_application"] =
          response.data.data["total_application"][0]["count"];
        this.dashcount["pending_application"] =
          response.data.data["pending_application"][0]["count"];
        this.dashcount["rejected_application"] =
          response.data.data["Reject_application"][0]["count"];
        this.dashcount["approved_application"] =
          response.data.data["Approved_application"][0]["count"];
      });
    },
    get_complaint_count() {
      var data = {
        user_id: "65a4d0a558b560c932b1b374",
        customer_id: "",
        category: "",
        title: "",
        category: "",
        type: "",
        status: "",
        client_id: "65a4f82f6177e69880ece5d6",
        ticket_no: "",
        agent_id: "",
        department_id: "",
        count: true,
        source: "",
      };
      var promise = apis.ticketlist(data, this.id);
      promise.then((response) => {
        this.totalRecords = response.data.data;
        this.dashcount["total_complaints"] = response.data.data;
      });
    },
    networkconnectivityreport() {
      var D = new Date(this.get_date_2);
      if (this.get_date_2) {
        var date =
          D.toLocaleDateString("en-US", { year: "numeric" }) +
          "-" +
          D.toLocaleDateString("en-US", { month: "2-digit" }) +
          "-" +
          D.toLocaleDateString("en-US", { day: "2-digit" });
      }
      var data = { date: date };
      var promise = apis.networkconnectivityreport(data);
      promise.then((response) => {
        this.lineData.datasets[0].data = Object.values(response.data);
      });
    },
    datausagereport() {
      var D = new Date(this.get_date);
      if (this.get_date) {
        var date =
          D.toLocaleDateString("en-US", { year: "numeric" }) +
          "-" +
          D.toLocaleDateString("en-US", { month: "2-digit" }) +
          "-" +
          D.toLocaleDateString("en-US", { day: "2-digit" });
      }
      var data = { date: date };
      var promise = apis.dashboarddatausagereport(data);
      promise.then((response) => {
        // alert(1);
        // console.log(this.barData.datasets[0].data);
        this.barData.datasets[0].data = Object.values(response.data);
      });
    },
    teacherlecturereportadmin() {
      var promise = apis.teacherlecturereportadmin();
      promise.then((response) => {
        // alert(1);
        // console.log(this.barData.datasets[0].data);
        this.barData1.labels = response.data.teacher;
        this.barData1.datasets[0].data = response.data.lectures;
      });
    },
    todayslecturereport() {
      var data = {
        limit: 5,
        page_no: 1,
      };
      var promise = apis.todayslecturereport(data);
      promise.then((response) => {
        // alert(1);
        // console.log(this.barData.datasets[0].data);
        this.todayslectures = response.data;
      });
    },
    formatCurrency(value) {
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
    isDarkTheme() {
      return this.$appState.darkTheme === true;
    },
    applyLightTheme() {
      this.barOptions = {
        plugins: {
          legend: {
            labels: {
              color: "#495057",
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
          y: {
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
        },
      };
      this.barOptions1 = {
        indexAxis: "y",
        plugins: {
          legend: {
            labels: {
              color: "#495057",
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
          y: {
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
        },
      };
      this.lineOptions = {
        plugins: {
          legend: {
            labels: {
              color: "#495057",
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
          y: {
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
        },
      };
    },
    applyDarkTheme() {
      this.lineOptions = {
        plugins: {
          legend: {
            labels: {
              color: "#ebedef",
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#ebedef",
            },
            grid: {
              color: "rgba(160, 167, 181, .3)",
            },
          },
          y: {
            ticks: {
              color: "#ebedef",
            },
            grid: {
              color: "rgba(160, 167, 181, .3)",
            },
          },
        },
      };
    },
  },
  components: {
    GoogleMap,
    Marker,
    MarkerCluster,
    InfoWindow,
    GMapMarker,
    Polyline,
    Loader,
  },
};
</script>
<style>
.color {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
    rgba(0, 0, 0, 0.04) 0px 10px 10px -5px !important;
  background: linear-gradient(
    90deg,
    rgba(131, 58, 180, 1) 0%,
    rgba(69, 70, 252, 1) 100%
  ) !important;
}
</style>